/**
 * Created by mykurisu on 2018/3/14.
 */
import React from 'react'
import {Popup} from 'react-weui'
import {connect} from 'react-redux'
import axios from 'axios'


class ClassroomEvaluation extends React.Component {
    constructor() {
        super()
        this.state = {
            popupShown: true,
            isChoosing: false,
            totalChoosing: null,
            goodEvaluation: [
                {
                    id: 1,
                    text: '声音清晰'
                },
                {
                    id: 2,
                    text: '内容有趣、实用'
                },{
                    id: 3,
                    text: '符合宣传内容'
                },
                {
                    id: 4,
                    text: '讲课富有感情'
                },
                {
                    id: 5,
                    text: '老师积极解答问题'
                },
                {
                    id: 6,
                    text: '物超所值'
                }
            ],
            badEvaluation: [
                {
                    id: 1,
                    text: '与宣传内容不符'
                },
                {
                    id: 2,
                    text: '声音嘈杂'
                },{
                    id: 3,
                    text: '内容枯燥'
                },
                {
                    id: 4,
                    text: '开课时间不准时'
                },
                {
                    id: 5,
                    text: '口齿不清晰'
                },
                {
                    id: 6,
                    text: '无师生互动'
                }
            ],
            evaluationChoosing: [],
            isFinish: false,
            canShow: true,
            isUserFinished: true
        }
    }

    componentDidMount() {
        if (window.localStorage.getItem(`lecture_evaluation_${this.props.lecture.id}`)) {
            this.setState({
                canShow: false
            })
        }
        axios.get(`/api/survey/3/detect?lecture_id=${this.props.lecture.id}`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        isUserFinished: false
                    })
                }
            })
    }

    handleTotalSelect(btn) {
        if (btn === 'good') {
            this.setState({
                isChoosing: true,
                totalChoosing: 'good',
                evaluationChoosing: []
            })
        } else {
            this.setState({
                isChoosing: true,
                totalChoosing: 'bad',
                evaluationChoosing: []
            })
        }
    }

    handleSubSelect(btn) {
        let list = this.state.evaluationChoosing
        let index = list.findIndex(item => item === btn)
        console.log(index)
        if (index !== -1) {
            list.splice(index, 1)
            this.setState({
                evaluationChoosing: list
            })
        } else {
            list.push(btn)
            this.setState({
                evaluationChoosing: list
            })
        }
    }

    handleSubmit() {
        let post_list = []
        let choosing_list = this.state.evaluationChoosing
        let target_list = this.state.totalChoosing === 'good' ? this.state.goodEvaluation : this.state.badEvaluation
        choosing_list.map(item => {
            post_list.push(target_list[item-1].text)
        })
        let quality = this.state.totalChoosing === 'good' ? '好' : '不好'
        axios.post(`/api/survey/3/create?lecture_id=${this.props.lecture.id}`, {
            quality: quality,
            evaluations: post_list
        })
            .then(res => {
                console.log('finish')
            })
        this.setState({
            isFinish: true
        }, () => {
            this.timer = setTimeout(() => {
                this.setState({
                    popupShown: false
                })
            }, 2700)
        })
    }

    render() {
        if (!this.props.EvaluationAudioLast) {
            return null
        }
        if (!this.state.canShow) {
            return null
        }
        if (this.state.isUserFinished) {
            return null
        }
        if (this.props.account.id === 28676863) {
            return null
        }
        window.MtaH5 && window.MtaH5.clickStat('lecture_evaluation_show')
        window.localStorage.setItem(`lecture_evaluation_${this.props.lecture.id}`, 1)
        return (
            <div id="classroom__evaluation">
                <Popup show={this.state.popupShown}
                       onRequestClose={e=>this.setState({popupShown: false})}>
                    <div className="classroom__evaluation">
                        <div className="eva__title">
                            <div className="title__close" onClick={e=>this.setState({popupShown: false})}>
                                <img
                                    src="https://static-1253442168.image.myqcloud.com/picture/4767145_80929cb7c5348a1aab30e3552a70fc6a.jpg"
                                    alt=""/>
                            </div>
                            课程内容评价
                        </div>
                        {this.state.isFinish
                            ?
                            <div className="eva__finish">
                                <div className="finish__container">
                                    <div className="finish__icon">
                                        <div className="icon__img">
                                            <img
                                                src="https://static-1253442168.image.myqcloud.com/picture/4767145_465611b6312dffb4ab31dd803609c6c2.jpg"
                                                alt=""/>
                                        </div>
                                    </div>
                                </div>
                                <div className="finish__text">
                                    感谢评价
                                </div>
                            </div>
                            :
                            <div className="eva__selectArea">
                                <div className="selectArea__total">
                                    <div className={this.state.totalChoosing === 'good' ? 'total__item total__item-active' : 'total__item'} onClick={() => this.handleTotalSelect('good')}>
                                        好
                                    </div>
                                    <div className={this.state.totalChoosing === 'bad' ? 'total__item total__item-active' : 'total__item'} onClick={() => this.handleTotalSelect('bad')}>
                                        不好
                                    </div>
                                </div>
                                <div className={this.state.totalChoosing ? 'selectArea__gap-text selectArea__gap-textActive' : 'selectArea__gap-text'}>
                                    {(() => {
                                        switch (this.state.totalChoosing) {
                                            case null:
                                                return '您的评价会让老师做的更好'
                                            case 'good':
                                                return '满意，值得表扬'
                                            case 'bad':
                                                return '不满意，需要改善'
                                        }
                                    })()}
                                </div>
                                {this.state.isChoosing &&
                                <div className="selectArea__sub">
                                    {this.state.totalChoosing === 'good'
                                        ?
                                        this.state.goodEvaluation.map(item => (
                                            <div className={this.state.evaluationChoosing.find(n => n === item.id) ? 'sub__item sub__item-active' : 'sub__item'} onClick={() => this.handleSubSelect(item.id)} key={`good_${item.id}`}>
                                                {item.text}
                                            </div>
                                        ))
                                        :
                                        this.state.badEvaluation.map(item => (
                                            <div className={this.state.evaluationChoosing.find(n => n === item.id) ? 'sub__item sub__item-active' : 'sub__item'} onClick={() => this.handleSubSelect(item.id)} key={`bad_${item.id}`}>
                                                {item.text}
                                            </div>
                                        ))
                                    }
                                    <div className="sub__submit" onClick={() => this.handleSubmit()}>
                                        匿名提交
                                    </div>
                                </div>
                                }
                            </div>
                        }
                    </div>
                </Popup>
            </div>
        )
    }
}

export default connect(state => ({
    EvaluationAudioCount: state.classroom.EvaluationAudioCount,
    EvaluationAudioLast: state.classroom.EvaluationAudioLast
}))(ClassroomEvaluation)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomEvaluation.js